import Visible from '@portalterreno/react-ui/Visible';
import { Col, Row } from '@portalterreno/react-ui-core/Grid';
import React from 'react';

import OnboardingHero from '../OnboardingHero';
import MobileLogo from './Mobile/Logo';
import StyledContainer from './StyledContainer';

const OnBoardingLayout: React.FC<
  React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>
> = ({ children, ...rest }) => {
  return (
    <StyledContainer {...rest}>
      <Row>
        <Visible desktop>
          <Col lg={4}>
            <OnboardingHero />
          </Col>
        </Visible>
        <Col
          lg={8}
          xs={4}
        >
          <Visible mobile>
            <MobileLogo />
          </Visible>

          {children}
        </Col>
      </Row>
    </StyledContainer>
  );
};

export default OnBoardingLayout;
